module.exports = __webpack_public_path__ + "static/media/karakinblur.2a65517f.png";